import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function AboutPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <div className="pt-32 pb-24">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-5xl font-bold text-gray-900 mb-8">{t('about.title')}</h1>
            
            <div className="prose prose-lg max-w-none">
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                {t('about.intro1')}
              </p>
              
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                {t('about.intro2')}
              </p>
              
              <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">{t('about.servicesTitle')}</h2>
              
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
                <div className="bg-gray-50 p-6 rounded-lg">
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">{t('about.services.interiorDesign.title')}</h3>
                  <p className="text-gray-700">
                    {t('about.services.interiorDesign.description')}
                  </p>
                </div>
                
                <div className="bg-gray-50 p-6 rounded-lg">
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">{t('about.services.construction.title')}</h3>
                  <p className="text-gray-700">
                    {t('about.services.construction.description')}
                  </p>
                </div>
                
                <div className="bg-gray-50 p-6 rounded-lg">
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">{t('about.services.furniture.title')}</h3>
                  <p className="text-gray-700">
                    {t('about.services.furniture.description')}
                  </p>
                </div>

                <div className="bg-gray-50 p-6 rounded-lg">
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">{t('about.services.cnc.title')}</h3>
                  <p className="text-gray-700">
                    {t('about.services.cnc.description')}
                  </p>
                </div>
              </div>
              
              <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">{t('about.whyChooseTitle')}</h2>
              
              <ul className="space-y-4 mb-12">
                <li className="flex items-start">
                  <i className="ri-check-line text-orange-500 text-2xl mr-3 mt-1 w-6 h-6 flex items-center justify-center"></i>
                  <span className="text-lg text-gray-700">{t('about.whyChoose.item1')}</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-orange-500 text-2xl mr-3 mt-1 w-6 h-6 flex items-center justify-center"></i>
                  <span className="text-lg text-gray-700">{t('about.whyChoose.item2')}</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-orange-500 text-2xl mr-3 mt-1 w-6 h-6 flex items-center justify-center"></i>
                  <span className="text-lg text-gray-700">{t('about.whyChoose.item3')}</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-orange-500 text-2xl mr-3 mt-1 w-6 h-6 flex items-center justify-center"></i>
                  <span className="text-lg text-gray-700">{t('about.whyChoose.item4')}</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-orange-500 text-2xl mr-3 mt-1 w-6 h-6 flex items-center justify-center"></i>
                  <span className="text-lg text-gray-700">{t('about.whyChoose.item5')}</span>
                </li>
              </ul>
              
              <div className="bg-orange-50 p-8 rounded-lg text-center">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">{t('about.cta.title')}</h3>
                <p className="text-lg text-gray-700 mb-6">
                  {t('about.cta.description')}
                </p>
                <Link
                  to="/contact"
                  className="inline-block px-8 py-3 bg-orange-500 text-white text-sm font-medium tracking-wide hover:bg-orange-600 transition-colors rounded-lg whitespace-nowrap"
                >
                  {t('about.cta.button')}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
}
